import { CommonModule } from '@angular/common';
import { Component, inject, Input, SecurityContext } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'angie-expandable-content',
	templateUrl: './expandable-content.component.html',
	styleUrls: ['./expandable-content.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslateModule]
})
export class ExpandableContentComponent {
	translateService = inject(TranslateService);
	private _openedText = this.translateService.instant('lup.show_less');
	private _closedText = this.translateService.instant('show_more');

	@Input() boxHeight: number = 300;
	@Input() set openedText(text: string) {
		if (!!text) {
			this._openedText = text;
		}
	}
	get openedText(): string {
		return this._openedText;
	}
	@Input() set closedText(text: string) {
		if (!!text) {
			this._closedText = text;
		}
	}
	get closedText(): string {
		return this._closedText;
	}
	@Input() enableBorder = false;
	@Input() flatTopBorder = false;
	@Input() flatBottomBorder = false;
	toggleValue = false;
	securityContext = SecurityContext;

	toggleContent(contentElement: HTMLElement): void {
		const contentHeight: number = contentElement.scrollHeight;
		contentElement.style.setProperty('--max-height', contentHeight + 'px');
		this.toggleValue = !this.toggleValue;
	}
}
